module.exports = __webpack_public_path__ + "img/document-text-blue.1519fb39.svg";